// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Avatars/style.css
 ** module id = 607
 ** module chunks = 0
 **/